import React from 'react';
import { ComponentBaseProps } from 'types';

type EmptyWrapperProps = { children: React.ReactNode } & ComponentBaseProps;
type EmptyTextProps = { text: React.ReactNode } & ComponentBaseProps;

export const EmptyWrapper = ({
  children,
  className = '',
  style = {},
}: EmptyWrapperProps) => {
  return (
    <div
      style={style}
      className={`w-full my-9 h-full flex flex-col justify-center items-center ${className}`}
    >
      {children}
    </div>
  );
};

export const EmptyText = ({ text, className = '' }: EmptyTextProps) => {
  return (
    <p className={`my-4 text-sm text-black font-bold ${className}`}>{text}</p>
  );
};

export const EmptyDescription = ({ text, className = '' }: EmptyTextProps) => {
  return <p className={`text-sm text-black  ${className}`}>{text}</p>;
};
